require('jquery');

$(() => {
  const $backToTopBtn = $('#backToTopBtn');

  $(window).scroll(() => {
    const scrollTop = $(window).scrollTop();

    if (scrollTop > 800) {
      $backToTopBtn
        .css('visibility', 'visible')
        .css('opacity', '1');
    } else {
      $backToTopBtn
        .css('visibility', 'hidden')
        .css('opacity', '0');
    }
  });

  $backToTopBtn.click(() => {
    $("html, body").animate({
      scrollTop: 0
    }, "smooth");
  })
});
